<script>
export default {
    name: 'Timepiece',
    props: {
        time: null,
        value: null,
        restaurant: {
            type: Object,
            default: () => {},
        },
    },
    computed: {
        innerTime() {
            return this.$moment(this.time.from)
        },
        innerValue() {
            return this.value ? this.$moment(this.value) : undefined
        },
        active() {
            return this.innerTime && this.innerValue
                ? this.innerTime.hour() === this.innerValue.hour() &&
                      this.innerTime.minute() === this.innerValue.minute()
                : false
        },
    },
    methods: {
        input() {
            this.$emit('input', this.innerTime)
        },
    },
}
</script>

<template lang="pug">
    .time(@click="input" :id="active ? 'activeTimepiece': undefined" :class="{'active': active}" role="button")
        span {{ time.from | toHour }}&nbsp;-&nbsp;{{ time.to | toHour }}
        hr.w-100.my-0.mx-4.mt-auto
</template>
